import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/shareModule/services/seo.service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss']
})
export class TermsOfServiceComponent implements OnInit {

  constructor(
    private seoService: SeoService
  ) { }

  ngOnInit(): void {

    this.seoService.update({
      title: 'Kachiing Terms of Service',
      description: 'Kachiing Terms of Service. Our platform is designed not only for convenience and community but also for providing multiple income-generating opportunities. Whether you\'re passionate about maintaining a safe digital space, helping businesses improve, or sharing your expertise, Kachiing offers diverse ways for you to earn.'
    })
  }

}
